import type { Channel, Options as PusherOptions } from 'pusher-js';

export interface PusherConfig extends PusherOptions {
  appKey: string;
}

export const PusherConnectionState = {
  Initialized: 'initialized',
  Connecting: 'connecting',
  Connected: 'connected',
  Unavailable: 'unavailable',
  Failed: 'failed',
  Disconnected: 'disconnected',
} as const;

// eslint-disable-next-line ts/no-redeclare
export type PusherConnectionState = (typeof PusherConnectionState)[keyof typeof PusherConnectionState];

export const ChannelStatus = {
  Pending: 'pending',
  Subscribing: 'subscribing',
  Active: 'active',
  Disconnected: 'disconnected',
  Reconnecting: 'reconnecting',
  Error: 'error',
} as const;

// eslint-disable-next-line ts/no-redeclare
export type ChannelStatus = (typeof ChannelStatus)[keyof typeof ChannelStatus];

export interface ActiveSubscription {
  id: string;
  channelName: string | null;
  operationName: string | undefined;
  subscribedAt: number;
  status: ChannelStatus;
  operation: {
    query: string;
    variables?: Record<string, unknown>;
    operationName?: string;
  };
  callbacks: {

    next: (result: any) => void;
    error: (err: unknown) => void;
    complete: () => void;
  };
  channel: Channel | null;
}
